import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import {
    Button,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    AccordionActions,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Divider,
    Checkbox,
    FormControlLabel,
    TextField
} from "@material-ui/core";
import SimpleInput from "../../components/Frequents/SimpleInput";
import SelectBoolean from "../../components/Frequents/SelectBoolean";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ReactToPrint from "react-to-print";
import Tags from "./Tags";
import moment from "moment";
import update from "immutability-helper";
import API from "../../actions";
import { UploadFile } from "../UploadImage/UploadImage";

export default props => {
    const printRef = useRef();
    const therapist = useSelector(state => state.data.therapist);
    const [clickedClient, setClickedClient] = useState(null);
    const [tags, setTags] = useState([]);
    const [allTags, setAllTags] = useState([]);
    const [isCompletedInput, setIsCompletedInput] = useState(true);
    const [allClientRequests, setallClientRequests] = useState([]);

    const updateAllClientRequests = (key, guidd) => {
        allClientRequests.push({ key: key, value: guidd });
        setallClientRequests(allClientRequests);
    };

    const removeClientRequest = (key, guidd) => {
        var index = allClientRequests.findIndex(i => i.value == guidd);
        if (index !== -1) {
            allClientRequests.splice(index, 1);
            setallClientRequests(allClientRequests);
        }
    };

    const changeValue = type => async value => {
        setIsCompletedInput(false);
        let guidd = uuidv4();

        let isValid = true;
        if (type === "CPR6Digit" && value.length !== 6) {
            isValid = false;
        } else if (type === "CPRLast4Digit" && value.length !== 4) {
            isValid = false;
        }
        if (isValid) {
            // updateAllClientRequests
            updateAllClientRequests(type, guidd);

            const temp = update(clickedClient, {
                [type]: { $set: value },
                updatedBy: { $set: therapist.nameFirst + " " + therapist.nameLast }
            });
            console.log("allClientRequests", allClientRequests);
            setClickedClient(temp);
            API.setClient(temp).then(
                success => {
                    // removeClientRequest
                    removeClientRequest(type, guidd);
                    if (allClientRequests.length === 0) {
                        setIsCompletedInput(true);
                    }
                    //remove guid from qu
                },
                err => {
                    // removeClientRequest
                    removeClientRequest(type, guidd);
                    if (allClientRequests.length === 0) {
                        setIsCompletedInput(true);
                    }
                    alert(err);
                }
            );
        }
    };

    useEffect(() => {
        (async () => {
            let allTagsMap = {};
            props.clients
                .map(c => JSON.parse(c.tags) || [])
                .flat()
                .forEach(t => {
                    if (t) allTagsMap[t] = true;
                });
            const allTags = [];
            Object.keys(allTagsMap).forEach(key => {
                allTags.push(key);
            });

            setAllTags(allTags);
            setClickedClient(props.clickedClient);
            setTags(JSON.parse(props.clickedClient.tags || "[]"));
        })();
    }, [props.clickedClient, props.clients]);

    const get4lastDigitCPR = async () => {
        var result = await API.get4LastDigitCPR();
        if (result) {
            let temp = update(clickedClient, {
                CPRLast4Digit: { $set: result.lastDigit },
                updatedBy: { $set: therapist.nameFirst + " " + therapist.nameLast }
            });
            setClickedClient(temp);
            API.setClient(temp).then(
                success => {},
                err => {
                    alert(err);
                }
            );
        }
    };

    useEffect(() => {
        console.log("Re-rendered: clickedClient updated", clickedClient);
    }, [clickedClient]);

    const handleInputChange = (id, value) => {
        setClickedClient(prevState => {
            if (!prevState || !prevState.formFields) return prevState;

            // Create a deep copy of the formFields array
            const updatedFields = prevState.formFields.map(field =>
                field.clientFormFieldsId === id ? { ...field, fieldValue: value } : field
            );

            // return { ...prevState, formFields: [...updatedFields] };

            const updatedClient = {
                ...prevState,
                formFields: updatedFields,
                updatedBy: therapist.nameFirst + " " + therapist.nameLast
            };

            // Send update to API
            API.setClient(updatedClient).then(
                () => {
                    // removeClientRequest(type, guidd);
                    // if (allClientRequests.length === 0) {
                    //     setIsCompletedInput(true);
                    // }
                },
                err => {
                    // removeClientRequest(type, guidd);
                    // if (allClientRequests.length === 0) {
                    //     setIsCompletedInput(true);
                    // }
                    alert(err);
                }
            );

            return updatedClient;
        });
    };

    if (!clickedClient || !therapist) return <></>;
    return (
        <Accordion expanded={props.expanded === "stamdata"} ref={printRef}>
            <AccordionSummary
                onClick={props.expand}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="stamdata-content"
                id="stamdata-header">
                <div>
                    <Typography>
                        Stamdata fra {moment(new Date(clickedClient.createdAt)).format("DD/MM/YYYY")} sidst rettet{" "}
                        {moment(new Date(clickedClient.updatedAt)).format("DD/MM/YYYY")}
                        {clickedClient.updatedBy ? " - " + clickedClient.updatedBy : ""}
                    </Typography>
                </div>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={3}>
                    <Grid item sm={4} style={{ width: "100%" }}>
                        <SimpleInput
                            style={{ flex: 1 }}
                            id="CPR6Digit"
                            name="CPR6Digit"
                            type="cprLast6Digit"
                            text="Fødselsdag"
                            required={true}
                            prop={clickedClient.CPR6Digit ? clickedClient.CPR6Digit : ""}
                            changeValue={changeValue("CPR6Digit")}
                            maxLength={6}
                            showError={true}
                        />
                    </Grid>
                    <Grid item sm={4} style={{ width: "100%" }}>
                        <SimpleInput
                            style={{ flex: 1 }}
                            id="CPRLast4Digit"
                            name="CPRLast4Digit"
                            type="cprLast4Digit"
                            text="De sidste 4 cifre i dit CPR nr"
                            required={true}
                            prop={clickedClient.CPRLast4Digit ? clickedClient.CPRLast4Digit : ""}
                            changeValue={changeValue("CPRLast4Digit")}
                            maxLength={4}
                            showError={true}
                        />
                    </Grid>
                    <Grid item sm={4} style={{ width: "100%" }}>
                        {/* <Button
                            variant="contained"
                            onClick={get4lastDigitCPR}
                            style={{ margin: "10px 0 10px 0", fontFamily: "Lato" }}>
                            Generer unik kode
                        </Button> */}
                    </Grid>
                    {[
                        ["nameFirst", "Fornavn", "text", true],
                        ["nameLast", "Efternavn", "text", true],
                        ["address", "Adresse", "text", true],
                        ["post", "Postnummer", "number", true],
                        ["town", "By", "text", true]
                    ].map(field => {
                        return (
                            <Grid key={field[0]} item sm={4} style={{ width: "100%" }}>
                                <SimpleInput
                                    name={"clientData" + field[0]}
                                    text={field[1]}
                                    key={"clientData" + field[0]}
                                    type={field[2]}
                                    required={field[3]}
                                    prop={clickedClient[field[0]] === null ? "" : clickedClient[field[0]]}
                                    changeValue={changeValue(field[0])}
                                    showError={true}
                                />
                            </Grid>
                        );
                    })}
                    {[
                        ["phonePrivate", "Telefon privat"],
                        ["phoneWork", "Telefon arbejde"],
                        ["phoneRelative", "Telefon pårørende"]
                    ].map(field => {
                        return (
                            <Grid key={field[0]} item sm={4} style={{ width: "100%" }}>
                                <SimpleInput
                                    name={"clientData" + field[0]}
                                    text={field[1]}
                                    type="phone"
                                    key={"clientData" + field[0]}
                                    prop={
                                        clickedClient[field[0]] === null
                                            ? ""
                                            : clickedClient[field[0]][0] === "+"
                                            ? clickedClient[field[0]].substring(3)
                                            : clickedClient[field[0]]
                                    }
                                    changeValue={changeValue(field[0])}
                                />
                            </Grid>
                        );
                    })}
                    <Grid item sm={4} style={{ width: "100%" }}>
                        <FormControl style={{ width: "100%", marginTop: "10px" }}>
                            <InputLabel id="clientDataCivilStatus">Civilstatus</InputLabel>
                            <Select
                                labelId="clientDataCivilStatus"
                                id="clientDataCivilStatus"
                                name="clientDataCivilStatus"
                                IconComponent={() => null}
                                onChange={async event => {
                                    const temp = update(clickedClient, {
                                        civilStatus: { $set: event.target.value },
                                        updatedBy: { $set: therapist.nameFirst + " " + therapist.nameLast }
                                    });
                                    setClickedClient(temp);
                                    await API.setClient(temp);
                                }}
                                value={
                                    clickedClient.civilStatus === null || undefined ? "" : clickedClient.civilStatus
                                }>
                                <MenuItem value={null} disabled>
                                    Vælg...
                                </MenuItem>
                                <MenuItem value={"Single"}>Single</MenuItem>
                                <MenuItem value={"Gift"}>Gift</MenuItem>
                                <MenuItem value={"Samboende"}>Samboende</MenuItem>
                                <MenuItem value={"Enke"}>Enke</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item sm={4} style={{ width: "100%" }}>
                        <SelectBoolean
                            key="clientDataSex"
                            name="clientDataSex"
                            text="Køn"
                            prop={clickedClient.sex === null || undefined ? "" : clickedClient.sex}
                            choice1="Mand"
                            choice2="Kvinde"
                            value1={1}
                            value2={2}
                            changeValue={changeValue("sex")}
                        />
                    </Grid>
                    {[
                        ["education", "Uddannelse", "text"],
                        ["children", "Antal børn", "number"],
                        ["doctor", "Egen læge", "text"],
                        ["otherTreater", "Anden behandler", "text"]
                    ].map(field => {
                        return (
                            <Grid key={field[0]} item sm={4} style={{ width: "100%" }}>
                                <SimpleInput
                                    name={"clientData" + field[0]}
                                    key={"clientData" + field[0]}
                                    text={field[1]}
                                    type={field[2]}
                                    prop={clickedClient[field[0]] === null ? "" : clickedClient[field[0]]}
                                    changeValue={changeValue(field[0])}
                                />
                            </Grid>
                        );
                    })}
                    {[
                        ["reminder", "SMS-påmindelse"],
                        ["followUp", "Opfølgningsbesked"],
                        ["newsletter", "Nyhedsbreve"]
                    ].map(field => {
                        return (
                            <Grid key={field[0]} item sm={4} style={{ width: "100%" }}>
                                <SelectBoolean
                                    name={"clientData" + field[0]}
                                    key={"clientData" + field[0]}
                                    text={field[1]}
                                    prop={clickedClient[field[0]] === null || undefined ? "" : clickedClient[field[0]]}
                                    choice1="Ja, tak"
                                    choice2="Nej, tak"
                                    value1={true}
                                    value2={false}
                                    changeValue={changeValue(field[0])}
                                    disabled={therapist.plan !== "pro"}
                                />
                            </Grid>
                        );
                    })}
                    <Grid item sm={4} style={{ width: "100%" }}>
                        <SimpleInput
                            name="clientDataMail"
                            key="clientDataMail"
                            type="mail"
                            text="E-mail"
                            prop={clickedClient.email === null ? "" : clickedClient.email}
                            changeValue={changeValue("email")}
                        />
                    </Grid>
                    <Grid container spacing={2}>
                        {clickedClient?.formFields?.length > 0 &&
                            clickedClient?.formFields?.map(question => {
                                const isRequired = question.isRequired || false;
                                return (
                                    <Grid item sm={4} style={{ width: "100%" }} key={question.clientFormFieldsId}>
                                        {question.fieldType === "text" || question.fieldType === "number" ? (
                                            <TextField
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                label={`${question.fieldName}${isRequired ? " *" : ""}`}
                                                variant="outlined"
                                                name={question.fieldName}
                                                type="text"
                                                value={question?.fieldValue || ""}
                                                onChange={e => {
                                                    handleInputChange(question.clientFormFieldsId, e.target.value);
                                                }}
                                            />
                                        ) : (
                                            question.fieldType === "checkbox" && (
                                                <FormControlLabel
                                                    style={{ width: "100%", padding: "7px 0" }}
                                                    control={
                                                        <Checkbox
                                                            checked={Boolean(question.fieldValue)}
                                                            onChange={e =>
                                                                handleInputChange(
                                                                    question.clientFormFieldsId,
                                                                    e.target.checked
                                                                )
                                                            }
                                                        />
                                                    }
                                                    label={
                                                        <span>
                                                            {question.fieldName}
                                                            {isRequired && <span style={{ color: "#f44336" }}> *</span>}
                                                        </span>
                                                    }
                                                />
                                            )
                                        )}
                                    </Grid>
                                );
                            })}
                    </Grid>
                    <Grid item sm={12} md={8} style={{ width: "100%", paddingTop: "14px" }}>
                        <UploadFile therapist={therapist} client={clickedClient} uploadInDrive={props.uploadInDrive} />
                    </Grid>
                    <Grid item sm={8} style={{ width: "100%", paddingTop: "14px" }}>
                        {tags ? (
                            <Tags
                                key={clickedClient.id}
                                tags={allTags}
                                selected={tags}
                                onChange={async value => {
                                    const tagsMap = {};
                                    const tagsNoDuplicates = [];
                                    value.flat().forEach(v => {
                                        if (tagsMap[v]) return;
                                        tagsMap[v] = true;
                                        tagsNoDuplicates.push(v);
                                    });

                                    const temp = update(clickedClient, {
                                        tags: { $set: JSON.stringify(tagsNoDuplicates) },
                                        updatedBy: { $set: therapist.nameFirst + " " + therapist.nameLast }
                                    });
                                    setClickedClient(temp);
                                    await API.setClient(temp);
                                }}
                            />
                        ) : (
                            <></>
                        )}
                    </Grid>
                </Grid>
            </AccordionDetails>
            <Divider />
            <AccordionActions>
                <ReactToPrint trigger={() => <Button size="small">Print</Button>} content={() => printRef.current} />
                <Button disabled={!isCompletedInput} size="small" onClick={props.expand}>
                    Luk
                </Button>
            </AccordionActions>
        </Accordion>
    );
};
